<template>
    <transition name="slide-main" :duration="{leave: 600}" v-if="controls.thumbsUpIsActive">
        <div v-if="controls.thumbsUp">
            <transition name="slide-fade">
                <div v-if="isLoaded">
                    <hr class="w-50" />
                    <i class="far fa-check fa-2x text-success"></i>
                    <p class="sau-font xs">Thank you for providing feedback</p>
                </div>
            </transition>
        </div>
        <div v-else>
            <transition name="slide-fade">
                <div v-if="staffHasFeedback && feedbackChecked">
                    <hr class="w-50" />
                    <i class="far fa-check fa-2x text-success"></i>
                    <p class="sau-font xs sau-pm-reset">You've given {{staff.author.first_name}} a rating.</p>
                </div>
            </transition>
            <transition name="slide-fade">
                <div v-if="feedbackChecked && !staffHasFeedback">
                    <!-- Show Feedback form -->
                    <sau-preloader v-if="controls.processingFeedback"></sau-preloader>
                    <div v-else>
                        <p class="sau-font xs sau-pm-reset py-2">Rate your conversation with {{staff.author.first_name}}?</p>
                        <div class="sau-thumbs-review" :class="{'active':controls.thumbsRating === false}" @click="setConversationThumb(false)">
                            <i class="fas fa-thumbs-down"></i>
                        </div>
                        <div class="sau-thumbs-review" :class="{'active':controls.thumbsRating === true}" @click="setConversationThumb(true)">
                            <i class="fas fa-thumbs-up"></i>
                        </div>

                        <!-- Show Comment form -->
                        <transition enter-active-class="animated rubberBand">
                            <div v-if="controls.thumbsRating !== null">
                                <div>
                                    <textarea class="form-control form-control-sm w-75 mx-auto my-2" id="feedback" rows="4" v-model="formModels.comment" placeholder="Any comments?"></textarea>
                                    <a href="#" @click.prevent="submitConversationRating" class="btn btn-primary btn-sm">Send Feedback</a>
                                </div>
                            </div>
                        </transition>
                    </div>
                </div>
            </transition>
        </div>
    </transition>
</template>

<script>
export default {
    props:['staff', 'conversationid'],
    data(){
        return{
            controls:{
                thumbsUp:false,
                thumbsRating: null,
                thumbsUpIsActive:true,
                processingFeedback:false
            },
            formModels:{
                comment:''
            },
            feedbackGiven: false,
            isLoaded: false,
            staffHasFeedback: false,
            feedbackChecked: false
        }
    },
    created() {
        this.startApp();
    },
    methods:{
        startApp() {
            // Check any existing feedback for this ticket
            this.checkConversationFeedback(this.conversationid).then(response => {
                let feedback = response.data;
                if(feedback) {
                    this.checkStaffFeedback(feedback);
                }
            });
        },
        checkStaffFeedback(feedback) {
            _.forIn(feedback, response => {
                if(response.reply_id == null) { // Skip over the feedback from individual replies
                    if(response.staff == this.staff.author.email) {
                        this.staffHasFeedback = true;
                    }
                }

            });
            if(this.staffHasFeedback == '') {
                this.staffHasFeedback = false;
            }
            this.feedbackChecked = true;
        },
        contentReady(isLoaded) {
            this.isLoaded = isLoaded;
        },
        setConversationThumb(submittedRating){
            this.controls.thumbsRating = submittedRating;
        },
        submitConversationRating(){
            if(this.feedbackGiven) return;
            // Feedback has been given - prevent multiple submits
            this.feedbackGiven = true;
            //Turn on loading circles

            this.controls.processingFeedback = true;

            let data = {
                staff: this.staff.author.email,
                rating:this.controls.thumbsRating,
                comment:this.formModels.comment
            }

            this.sendConversationFeedback(this.conversationid, data)
                .then(response => {
                    // Show submitted message
                    this.controls.processingFeedback = false;
                    this.isLoaded = true;
                    this.controls.thumbsUp = true;
                }).catch(error => {

                    this.feedbackGiven = false;
                    this.controls.processingFeedback = false;

                    if(error.response.status === 403) {
                        this.$swal({
                            title: 'Your session has expired',
                            text: 'Please log in again to continue',
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonClass: 'btn btn-primary',
                            cancelButtonClass: 'btn btn-link',
                            confirmButtonText: 'Login',
                            reverseButtons: true,
                            allowOutsideClick: false,
                            buttonsStyling: false,
                            preConfirm() {
                                window.location.reload();
                            }
                        })
                    }
                });
        }
    }
}
</script>

<style>
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active, .slide-main-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active, .slide-main-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-15px);
  opacity: 0;
}
.slide-main-enter, .slide-main-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(15px);
  opacity: 0;
}
</style>
